
import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";

import PropTypes from "prop-types";
import classNames from 'classnames';
import {withStyles} from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';


import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import Checkbox from '@material-ui/core/Checkbox';

import GoogleIcon from 'mdi-material-ui/Google'
import FacebookIcon from 'mdi-material-ui/Facebook'


import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';

import DialogContent from '@material-ui/core/DialogContent';

import Slide from '@material-ui/core/Slide';

import withMobileDialog from '@material-ui/core/withMobileDialog';


import SnackbarContentWrapper from './../reusableComponents/SnackbarContentWrapper'


const styles = theme => ({
  paper:{

    minWidth: 800,
    borderRadius: 5,
    boxShadow: theme.shadows[10],

    backgroundImage: "url('https://i.imgur.com/zXKU0XL.jpg')",
    backgroundSize: "cover",

  },
  paperMobile:{
    backgroundImage: "url('https://i.imgur.com/zXKU0XL.jpg')",
    backgroundSize: "cover",
  },
  socialMedia:{
    display: "flex",
    flexDirection: "column",


    borderColor: theme.palette.divider,


    paddingBottom: theme.spacing.unit * 3,
  },
  soicalMediaButton:{

    marginTop: theme.spacing.unit * 3,

    color: "white",
    justifyContent:"left"
  },
  buttonGoogle:{
    background:"#EA4335",
  },
  buttonFacebook:{
    background: "#3b5998",
  },
  buttonTwitter:{
    background: "#0084B4",
  },

  logInForm:{
    paddingTop:  theme.spacing.unit * 3,

  },
  messageWrapper:{

  },
  message:{
    height: 35,
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    maxWidth: "inherit",
  },

  closeButton:{
    position: "absolute",
    right: 0,
    top: 0,

  },

  link:{
    textDecoration: "underline",
    color: "blue",
    cursor: "pointer",

    "&:active":{
      color: "purple"
    }
  },
})

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class DialogSignIn extends Component {
  state = {
    active: false,

    displayRegisterForm: false,
    displayLoginForm: true,
    displayPasswordResetForm: false,

    messageClosed: false,
    usernameInput: '',
    passwordInput: '',
    showInputError: false,
    showPassword: false,

    userAgreement: false,

    newUser: {},

  }

  static contextTypes = {
    router: PropTypes.object
  }

  componentWillUpdate(nextProps) {
    //console.log(this.props.loginDialogInfo)
    if (nextProps.auth) {
      if(this.props.loginDialogInfo === "userNotFound" ){
        this.props.loginDialogState(true)
      }if(this.props.loginDialogInfo === "incorrectCredentials" ){
        this.props.loginDialogState(true)
      }if(this.props.loginDialogInfo === "success" ){
        this.props.loginDialogState(false)
        this.context.router.history.push('/mojestave')
      }else{
        this.props.loginDialogState(false)
      }
    }
  }


  handleDialogState = ()=>{
    this.props.loginDialogState(false)
  }

  handleInputField= (e)=>{
    this.setState({[e.target.id]: e.target.value, showInputError: false})
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }))
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleMessageClose = () =>{
    this.setState({messageClosed: true})
  }

  handleRegistrationClick = ()=>{
    this.setState({displayRegisterForm: !this.state.displayRegisterForm, displayLoginForm: !this.state.displayLoginForm})
  }

  handlePasswordResetClick = ()=>{
    this.setState({displayRegisterForm: false, displayLoginForm: false, displayPasswordResetForm: true})
  }

  handlePasswordResetBackClick = ()=>{
    this.setState({displayRegisterForm: false, displayLoginForm: true, displayPasswordResetForm: false})
  }

  handleRegistrationInputField = (e)=>{
    let newUser = this.state.newUser
    newUser[e.target.id] = e.target.value
    this.setState({newUser})
  }

  handleUserAgreementChange = ()=>{
    this.setState({userAgreement: !this.state.userAgreement})
  }

  showUserAgreement = ()=>{
    this.props.showUserAgreementDialog(true)
  }



  registerNewUser = ()=>{
    let newUser = this.state.newUser
    if(newUser.password === newUser.passwordCheck){
      this.props.createNewUser(newUser.userEmail, newUser.password)
      this.handleRegistrationClick()
    }else{
      this.setState({passwordDoesntMatch: true})
      this.props.showWebpageDisplayedInfo("Gesli se ne ujemata!", "", "error")
    }
  }

  resetPassword = ()=>{
    if(this.state.usernameInput){
      this.props.passwordResetRequest(this.state.usernameInput)
      this.handlePasswordResetBackClick()
    }

  }

  logIn(){
    if( this.state.usernameInput && this.state.passwordInput ) {
      this.props.signIn(this.state.usernameInput, this.state.passwordInput)
      this.setState({usernameInput: "", passwordInput: ""})
    }else{
      this.setState({showInputError: true})
    }
  }

  passwordResetForm = ()=>{
    const {classes} = this.props
    const {showInputError, usernameInput, passwordInput} = this.state
    return(
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={24} className={classes.logInForm}>
          <Grid item xs={12}>
            <Typography >POZABIL SEM GESLO</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth  error={showInputError && passwordInput === ''}>
              <InputLabel  htmlFor="usernameInput" >E-naslov</InputLabel>
              <Input
                id="usernameInput"
                value={usernameInput}
                onChange={this.handleInputField}

              />
            </FormControl>
          </Grid>
          <Grid item xs={12} style={{display:"flex",justifyContent:"flex-end"}}>
              <Button  color="primary"  onClick={this.handlePasswordResetBackClick}>Nazaj</Button>
              <Button variant="contained" color="primary" onClick={this.resetPassword}>Pošlji</Button>

          </Grid>

        </Grid>
      </Grid>
    )
  }

  loginForm = ()=>{
    const {classes} = this.props
    const {showInputError, usernameInput, passwordInput} = this.state
    return(
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={24} className={classes.logInForm}>
          <Grid item xs={12}>
            <FormControl fullWidth  error={showInputError && passwordInput === ''}>
              <InputLabel  htmlFor="usernameInput" >E-poštni naslov</InputLabel>
              <Input
                id="usernameInput"
                value={usernameInput}
                onChange={(e)=>this.handleInputField(e)}

              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth error={showInputError && passwordInput === ''}>
              <InputLabel  htmlFor="passwordInput" >Geslo</InputLabel>
              <Input
                id="passwordInput"
                type="password"
                value={passwordInput}
                onChange={(e)=>this.handleInputField(e)}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
              <Button variant="contained" color="primary" fullWidth onClick={ ()=> this.logIn() }>Prijava</Button>
          </Grid>
          <Grid item xs={12} style={{display: "flex"}}>
              <Button style={{flexGrow: 6}} color="primary" onClick={this.handleRegistrationClick} >Registriraj se </Button>

              <Button style={{flexGrow: 6}}  color="primary"  onClick={this.handlePasswordResetClick}>Pozabil geslo ? </Button>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  registerForm = ()=>{
    const {classes} = this.props
    const {showInputError, usernameInput, passwordInput, newUser} = this.state
    return(
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={24} className={classes.logInForm}>
          <Grid item xs={12}>
            <FormControl fullWidth  error={showInputError && passwordInput === ''}>
              <InputLabel  htmlFor="usernameInput" >E-poštni naslov</InputLabel>
              <Input
                id="userEmail"
                value={newUser.userEmail ? newUser.userEmail: ""}
                onChange={(e)=>this.handleRegistrationInputField(e)}

              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth error={this.state.passwordDoesntMatch}>
              <InputLabel htmlFor="passwordInput" >Geslo</InputLabel>
              <Input
                id="password"
                type="password"
                value={newUser.password ? newUser.password :""}
                onChange={(e)=>this.handleRegistrationInputField(e)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth error={this.state.passwordDoesntMatch}>
              <InputLabel htmlFor="passwordInput" >Ponovno vpiši geslo</InputLabel>
              <Input
                id="passwordCheck"
                type="password"
                value={newUser.passwordCheck ? newUser.passwordCheck: ""}
                onChange={(e)=>this.handleRegistrationInputField(e)}
              />
            </FormControl>

          </Grid>
          <Grid item xs={12} >
            <div style={{display: "flex", flexDirection:"row", justifyContent: "flex-start", alignContent: "center"}}>
              <Checkbox
                checked={this.state.userAgreement}
                onChange={this.handleUserAgreementChange}

              />
            <Typography style={{fontSize: 12, paddingTop: 15}}>Strinjam se s pogoji uporabe. <span onClick={this.showUserAgreement} className={classes.link}>Več o pogojih tukaj!</span></Typography>
            </div>

          </Grid>
          <Grid item xs={12} >
            <div style={{display:"flex", flexDirection: "row", justifyContent:"flex-end"}}>
              <Button  variant="text" color="primary"  onClick={this.handleRegistrationClick}>Nazaj</Button>
              <Button disabled={!this.state.userAgreement} variant="contained" color="primary"  onClick={this.registerNewUser}>Potrdi</Button>
            </div>

          </Grid>
        </Grid>
      </Grid>
    )
  }

  render() {

    const {classes, loginDialog, auth, loginDialogInfo, registrationInfo, fullScreen} = this.props
    const {showInputError, messageClosed, usernameInput, passwordInput, displayRegisterForm, displayLoginForm, displayPasswordResetForm} = this.state

    return (
        <Dialog
          open={loginDialog}
          fullScreen={fullScreen}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleDialogState}
          onBackdropClick={this.handleDialogState}
          aria-labelledby="form-dialog-title"
          classes={!this.props.fullScreen ? {paper:classes.paper} : {paper: classes.paperMobile}}
        >

            {
              (loginDialogInfo === "userNotFound" || messageClosed) && (
                <div className={classes.messageWrapper}>
                  <SnackbarContentWrapper
                    variant="error"
                    className={classes.message}
                    message="Uporabniški račun ne obstaja!"
                    onClose={this.handleMessageClose}
                  />
                </div>
              )
            }
            {
              (loginDialogInfo === "incorrectCredentials" || messageClosed) && (
                <div className={classes.messageWrapper}>
                  <SnackbarContentWrapper
                    variant="error"
                    className={classes.message}
                    message="Napačno geslo!"
                    onClose={this.handleMessageClose}
                  />
                </div>
              )
            }
            {
              (loginDialogInfo === "passwordReset" || messageClosed) && (
                <div className={classes.messageWrapper}>
                  <SnackbarContentWrapper
                    variant="info"
                    className={classes.message}
                    message={"Navodila za zamenjavo gesla, so bila poslan na "+this.state.usernameInput+"!"}
                    onClose={this.handleMessageClose}
                  />
                </div>
              )
            }

            <DialogContent  >
              <Grid container justify="center" spacing={24} alignItems='center' >
                  <Grid item xs={12} sm={12} md={6}>
                    <div className={classes.socialMedia}>
                      <Button variant="contained" onClick={()=>this.props.signInWithProvider("google")} className={classNames(classes.buttonGoogle, classes.soicalMediaButton)} fullWidth>
                        <GoogleIcon color="inherit" style={{marginRight: "20%"}} /> 
                        {displayRegisterForm ? "Registriraj se z Google+" : "Prijavi se z Google+"}
                      </Button>

                    </div>
                    <div>
                      <Typography style={{fontSize: 12, padding: 15, textAlign: "center"}}>Z registracijo preko socialnega omrežja, se hkrati tudi strinjam s pogoji uporabe! <span onClick={this.showUserAgreement} className={classes.link}>Več o pogojih tukaj!</span></Typography>
                    </div>
                    {displayRegisterForm && (
                     <Button  variant="text" color="primary"  onClick={this.handleRegistrationClick} fullWidth>Nazaj</Button>
                    )}
                   
                  </Grid>
                  {/*
                    // proces dela neke probleme... onemogocen do nadalnega
                    displayRegisterForm && this.registerForm()
                  */}
                  {
                    displayLoginForm && this.loginForm()
                  }
                  {
                    displayPasswordResetForm && this.passwordResetForm()
                  }
              </Grid>
            </DialogContent>
        </Dialog>
    );
  }
}

DialogSignIn.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,

};

function mapStateToProps({ auth, loginDialog, loginDialogInfo, registrationInfo }) {
  return {
    auth,
    loginDialog,
    loginDialogInfo,
    registrationInfo
  };
}

export default withMobileDialog()(connect(mapStateToProps, actions)(withStyles(styles, { withTheme: true })(DialogSignIn)));



// WEBPACK FOOTER //
// ./src/components/signIn/DialogSignIn.js